import { createApi } from "@reduxjs/toolkit/query/react";
import { useDispatch } from "react-redux";

import { abfSerializeQueryArgs, marketsBaseQuery } from "./util";
import { PortfolioRewards, PortfolioRewardsFilter, PortfolioStats } from "../types";
import { GET_PORTFOLIO_STATS_ROUTE, ROUTE_PORTFOLIO_REWARDS } from "../constants";

const MARKETS_TAG = "Markets";
const PORTFOLIO_REWARDS_TAG = "PortfolioRewards";
export const marketsApi = createApi({
    reducerPath: "marketsApi",
    tagTypes: [MARKETS_TAG, PORTFOLIO_REWARDS_TAG],
    baseQuery: marketsBaseQuery,
    serializeQueryArgs: abfSerializeQueryArgs,

    endpoints: (builder) => ({
        portfolioStats: builder.query<PortfolioStats, void>({
            providesTags: [MARKETS_TAG],
            query() {
                return {
                    url: GET_PORTFOLIO_STATS_ROUTE,
                    method: "POST"
                };
            }
        }),
        portfolioRewards: builder.query<PortfolioRewards, PortfolioRewardsFilter>({
            providesTags: [PORTFOLIO_REWARDS_TAG],
            query(filter) {
                return {
                    url: ROUTE_PORTFOLIO_REWARDS,
                    method: "POST",
                    body: filter
                };
            }
        })
    })
});

export const { usePortfolioStatsQuery, usePortfolioRewardsQuery } = marketsApi;

export const useMarketsApi = () => {
    const dispatch = useDispatch();

    return {
        resetRewardsApi: () => dispatch(marketsApi.util.invalidateTags([PORTFOLIO_REWARDS_TAG])),
        resetNapoleonApi: () => dispatch(marketsApi.util.invalidateTags([MARKETS_TAG]))
    };
};
